import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';
import { JobCreateView } from 'src/sections/job2/view';
// sections

// ----------------------------------------------------------------------

export default function JobCreatePage(props) {
  let { state } = useLocation();
  console.log(state);

  return (
    <>
      <Helmet>
        <title> Hireintel - Create a new Job</title>
      </Helmet>

      <JobCreateView />
    </>
  );
}
